var map = {
	"./bcom/PPC.bcom": [
		"9d6ab776",
		7489
	],
	"./bcom/PPC.bcom.vue": [
		"9d6ab776",
		7489
	],
	"./mcom/PPC.mcom": [
		"4d7d913a",
		4735
	],
	"./mcom/PPC.mcom.vue": [
		"4d7d913a",
		4735
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "44403ab7";
module.exports = webpackAsyncContext;